import { appHttp } from '@/shared/http'

// Sysadmin report-maintenance transport (v3 CacheClearButton.vue:38-56): schedule-scoped
// cache invalidation and analysis re-execution against the generic controller endpoints.

export interface ReportMaintenancePayload {
  schedule_id: number
  workspace_id: number
}

export class ReportMaintenanceApi {
  constructor(private readonly app: Pick<typeof appHttp, 'post'> = appHttp) {}

  async clearCache(payload: ReportMaintenancePayload): Promise<void> {
    await this.app.post('/generic/clear-cache', payload)
  }

  async executeAnalysis(payload: ReportMaintenancePayload): Promise<void> {
    await this.app.post('/generic/execute-analysis', payload)
  }
}
